// Корень маршрутов. Каркас «Табеля» (меню, лист, шапка) добавляет T029 в src/shell/.
// Содержимое страницы — в <main id="main">: на него ведёт «Перейти к содержимому».
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { RouterContext } from '../app/router-context.ts';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <a href="#main" className="kp-skip t-btn t-btn-secondary">
        Перейти к содержимому
      </a>
      <Outlet />
    </>
  );
}
